import moment from "moment";
import React, { forwardRef } from "react";
import { Col, Row, Table } from "reactstrap";
import SakeenaLogo from "../../../assets/images/logo/inv-lh-logo.png";
import TextHeader from "../../../assets/images/logo/inv-lh-tx.png";
import AddowLogo from "../../../assets/images/logo/inv-logo2.png";

const MergeReceipt = forwardRef(({ receiptData = [], store}, ref) => {
  
  
  // Calculate the total amount
  const totalAmount = receiptData?.reduce(
    (acc, receipt) => acc + receipt.amount,
    0
  );

  const receiptNumbers = receiptData
    ?.map((receipt) => "#" + receipt.receiptNo)
    .join(", ");

  return (
    <div ref={ref}>
      {/* Logo and Header Section */}
      <Row className="mb-4">
        <Col>
          <img
            src={SakeenaLogo}
            alt="Company Logo"
            style={{ maxWidth: "150px" }}
          />
        </Col>
        <Col className="text-center mt-1">
          <img
            src={TextHeader}
            alt="Company Logo"
            style={{ maxWidth: "300px" }}
          />
          <span
            className="badge mt-2 h5"
            style={{
              backgroundColor: "#f0f0f0",
              padding: "10px 50px",
              borderRadius: 20,
              fontWeight: "bold",
              color: "black",
              border: "1px solid #dcdcdc",
              fontSize: "20px",
            }}
          >
            RECEIPTS
          </span>
        </Col>
        <Col>
          <img
            src={AddowLogo}
            alt="Company Logo"
            style={{ maxWidth: "150px" }}
          />
        </Col>
      </Row>

      {/* Items Table */}
      <Row style={{ margin: "10px 5px" }}>
        <Col>
          <div
            className="bg-primary text-white p-1 fw-bold"
            style={{
              marginRight: "15px",
            }}
          >
            <div className="d-flex justify-content-between fw-bold">
              <span>RECEIPTS: {receiptNumbers}</span>
              <span>DATE ISSUED: {moment().format("DD/MMM/YYYY")}</span>
            </div>
            <div
              className="d-flex justify-content-between fw-bold"
              style={{ marginTop: "10px" }}
            >
              <span>
                Name:{" "}
                {
                  store?.data?.customerInfo?.name ||
                  "Customer"}
              </span>
            </div>
          </div>
          <table
            striped
            className="mt-2"
            style={{
              width: "100%",
              marginTop: "10px",
              borderCollapse: "collapse",
            }}
          >
            <thead striped>
              <tr
                style={{
                  backgroundColor: "#f0f0f0",
                  textAlign: "left",
                  borderBottom: "2px dashed #ccc",
                  height: "40px",
                  padding: "5px",
                }}
              >
                <th style={{ width: "20%" }}>Receipt #</th>
                <th style={{ width: "20%" }}>Date</th>
                <th style={{ width: "20%" }}>Invoice #</th>
                <th style={{ width: "20%" }}>Reference</th>
                <th style={{ width: "20%" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {receiptData.map((receipt, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid #ddd",
                    height: "40px",
                    fontSize: "15px",
                    textAlign: "left",
                    gap: "5px",
                  }}
                >
                  <td>#{receipt.receiptNo || ""}</td>
                  <td>{moment(receipt.createdAt).format("DD/MMM/YYYY")}</td>
                  <td>
                    {Array.isArray(receipt.invoiceId)
                      ? receipt.invoiceId
                          .map((invoice) => invoice.invoiceNo)
                          .join(", ")
                      : receipt?.invoiceId?.invoiceNo}
                  </td>
                  <td>{receipt?.reference || "N/A"}</td>
                  <td>${receipt.amount.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>

      {/* Summary Section */}
      <Row className="my-3" style={{ margin: "10px 5px" }}>
        <Col>
          <Table bordered style={{ textAlign: "center" }}>
            <tbody>
              <tr style={{ backgroundColor: "#f0f0f0" }}>
                <td>
                  <span>TOTAL AMOUNT :</span>
                  <span className="mx-1">${totalAmount.toFixed(2)}</span>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      {/* Footer Section */}
      <Row className="mb-4">
        <Col className="text-center">
          <h5> WE ARE HONORED TO HAVE YOU AS ONE OF OUR DEAR CUSTOMERS.</h5>
        </Col>
      </Row>

      {/* Signature Section */}
      <Row className="mb-2">
        <Col className="text-center">
          <p>SIGNATURE</p>
          <p>_______________________________________________</p>
        </Col>
      </Row>

      <Row className="text-center">
        <h5 className="mt-2">THANKS FOR YOUR COLLABORATION.</h5>
      </Row>
    </div>
  );
});

export default MergeReceipt;
